
























import { Component, Ref, Vue } from 'vue-property-decorator';
import { GiftEntity } from '@/entities/gift.entity';
import ThanksMessageItemPc from '../ThanksMessageItem/ThanksMessageItemPc.vue';
import ThanksMessageListMixin from './thanks-message-list.mixin';

@Component<ThanksMessageListPc>({
  components: { ThanksMessageItemPc },
})
export default class ThanksMessageListPc extends ThanksMessageListMixin {
  @Ref('refThanksMessageList') readonly refThanksMessageList: Vue | Element;

  get scrollEl(): Window | Element {
    if (this.refThanksMessageList instanceof Element) {
      return this.refThanksMessageList;
    }
    return this.refThanksMessageList.$el;
  }

  get cols() {
    if (this.$vuetify.breakpoint.xl) {
      return 3;
    }
    if (this.$vuetify.breakpoint.lgAndUp) {
      return 4;
    }
    if (this.$vuetify.breakpoint.smAndUp) {
      return 6;
    }
    return 12;
  }
  get colsNumber() {
    return 12 / this.cols;
  }
  getItemInCol(col: number): GiftEntity[] {
    return this.items.filter(
      (item, index) => index % this.colsNumber === col - 1,
    );
  }
  get contentHeight() {
    return `calc(100vh - ${260}px)`;
  }
}
